import React, { useEffect, useState } from "react";
import { Collapse } from "antd";
import Papa from "papaparse";
import url from "../../../services/url";
import axios from "../../../services/axios";
import { set } from "lodash";
import exportFromJSON from "export-from-json";
import swal from "sweetalert";
import { configConsumerProps } from "antd/lib/config-provider";
function CallStatusUpload() {
  const [loading, setLoading] = useState(true);
  const [csvfileError, setcsvfileError] = useState("");
  const { Panel } = Collapse;
  const [CallStatusData, setCallStatusData] = useState([]);
  const [callStatus, setCallStatus] = useState("");
  const [submitNullData, setSubmitNullData] = useState();
  const [submitCorrectData, setSubmitCorrectData] = useState();
  const [disableButton, setDisableButton] = useState(false);
  const [load, setLoad] = useState(true);
  const nullData = [];
  const correctData = [];
  //download sample file
  let data = [
    {
      mobileNo: "8844545454",
    },
  ];
  const exportType = "csv";

  const handleClickSample = () => {
    exportFromJSON({ data, exportType });
  };

  const downloadFinalData = () => {
    if (submitNullData !== undefined || []) {
      // const trimdata = CsvFinalSubmitData;
      //const merged = [...CsvFinalSubmitData, ...submitNullData];
      const merged = submitNullData;
      console.log("setttttttttttttttttt", merged);
      console.log("settttttttt nullllllt", submitNullData);
      const exactData = [];

      for (const element of merged) {
        let status;
        if (element.status === "Duplicate Phone") {
          status = "Duplicate Phone";
        } else if (element.status === "error") {
          status = "error";
        } else if (element.status === "Duplicate Email") {
          status = "Duplicate Email";
        } else {
          status = "Record Already Exist";
        }
        const dataSet = {
          mobileNo: element.mobileNo,

          reason: status,
        };
        exactData.push(dataSet);
      }
      console.log("data is present here", exactData);

      let data = exactData;
      const exportType = "csv";

      const handleClickSample = () => {
        exportFromJSON({ data, exportType });
      };

      handleClickSample();
    }

    window.location.reload();
  };

  useEffect(() => {
    getCallStatusMaster();
  }, []);

  //get call status master data
  const getCallStatusMaster = () => {
    axios
      .get("/callStatusMaster", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
      })
      .then((res) => {
        console.log(res.data);
        setCallStatusData(res.data);
      });
  };

  const [callStatusParameter, setCallStatusParamter] = useState([]);
  const handleCallStatus = (e) => {
    console.log("e.target", e.target.value);
    setCallStatus(e.target.value);
    const data = CallStatusData.filter((ele) => {
      return ele.name === e.target.value;
    });
    console.log("data", data[0]?.parameterList);
    setCallStatusParamter(data[0]?.parameterList);
    if (parameterValue !== "" && e.target.value !== "") {
      setcsvfileError("");
    }
  };
  const [parameterValue, setParameterValue] = useState("");
  const handleParameter = (e) => {
    setParameterValue(e.target.value);
    if (callStatus !== "" && e.target.value !== "") {
      setcsvfileError("");
    }
  };

  const [csvdata, setcsvdata] = useState([]);
  const handlecsvdata = (e) => {
    const files = e.target.files;
    let selectedFile = e.target.files[0];
    let size = selectedFile.size / 1000000;

    // console.log("csv size",size)
    if (size < 5) {
      if (files) {
        Papa.parse(files[0], {
          header: true,
          complete: function (results) {
            setcsvfileError("");
            setcsvdata(results.data);

            const finaldata = results.data;
            console.log("final dataaa", finaldata.length);
            if (finaldata.length <= 2001) {
              if (finaldata.length >= 1) {
                for (let i = 0; i < 1; i++) {
                  let finalDataHeader = Object.keys(finaldata[i]);
                  console.log("arrayyyyyy", finalDataHeader);
                  let headersVerify = ["mobileNo"];
                  //for headers verification
                  let checker = (arr, target) =>
                    target.every((v) => arr.includes(v));
                  const validateHeader = checker(
                    finalDataHeader,
                    headersVerify
                  );
                  if (!validateHeader) {
                    setcsvfileError("Headers are mismatched");
                  } else {
                    var format = /[!@#$%^&*()_+\-=\[\]{0-9};':"\\|,.<>\/?]+/;
                    let isnum = /^\d+$/;

                    //for finding data with duplicate numbers
                    const lookup = finaldata.reduce((a, e) => {
                      a[e.mobileNo] = ++a[e.mobileNo] || 0;
                      return a;
                    }, {});
                    const data = finaldata.filter((e) => lookup[e.mobileNo]);

                    console.log("dataa lookuo", data);

                    // if (data) {
                    //   console.log("duplicate", data);
                    //   for (const element of data) {
                    //     const junkData = {
                    //       mobileNo: element.mobileNo,
                    //       status: "Duplicate Phone",
                    //     };
                    //     nullData.push(junkData);
                    //   }
                    // }

                    for (let i = 0; i < finaldata.length - 1; i++) {
                      var str4 = "" + finaldata[i].mobileNo;

                      if (
                        finaldata[i].mobileNo === "" ||
                        finaldata[i].mobileNo.length !== 10 ||
                        !str4.replace(/\s/g, "").length ||
                        !isnum.test(finaldata[i].mobileNo)
                      ) {
                        const junkData = {
                          mobileNo: finaldata[i].mobileNo,
                          status: "error",
                        };
                        nullData.push(junkData);
                      } else {
                        const correctObj = {
                          mobileNo: finaldata[i].mobileNo,
                        };
                        correctData.push(correctObj);
                      }
                    }

                    setSubmitNullData(nullData);
                    console.log("junk data", nullData);

                    if (nullData?.length > 0) {
                      swal({
                        title: "Please download the Error Report?",
                        text: "Remove errors and submit the file again!",
                        icon: "warning",
                        dangerMode: true,
                      });
                    }
                    // filtered data for getting only correct data from all data
                    const results = correctData.filter(
                      ({ mobileNo: id1 }) =>
                        !data.some(({ mobileNo: id2 }) => id2 === id1)
                    );
                    setSubmitCorrectData(results);
                    console.log("correct data", results);
                  }
                }
              } else {
                setcsvfileError("no data found in csv file");
              }
            } else {
              setcsvfileError("Limit exceeded! (max-2000 candidates allowed)");
            }
          },
        });
      }
    } else {
      setcsvfileError("file size should be less than 5 mb");
    }
  };

  const handleSubmitCsv = (e) => {
    e.preventDefault();
    setDisableButton(true);
    if (
      csvdata !== "" &&
      csvfileError === "" &&
      callStatus !== "" &&
      parameterValue !== ""
    ) {
      setcsvfileError("");
      setDisableButton(false);
      console.log("pass");
      const obj = {
        userId: localStorage.getItem("user.id"),
        callMasterId: callStatus,
        callStatusMasterId: parameterValue,
        mobileNoList: csvdata,
      };
      console.log("pass", obj);
      var config = {
        method: "patch",
        url: url("/callStatusParametersMaster/UpdateCallStatus"),
        maxContentLength: "infinity",
        maxBodyLength: "infinity",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
        data: obj,
      };

      axios(config)
        .then(function (response) {
          setDisableButton(false);
          if (response !== null) {
            setLoad(true);

            swal({
              title: `Records Inserted`,
              text: `Successfully`,
              icon: "success",
              dangerMode: true,
            }).then((willDelete) => {
              if (willDelete) {
                window.location.reload();
              }
            });
            // window.location.reload();
          }
        })
        .catch(function (error) {
          console.log(error);
          setLoad(true);
          swal("Oops...", "Something went wrong!", "Network Error");
        });
    } else {
      setcsvfileError("All fields are mandatory");
      setDisableButton(false);
    }
  };
  return (
    <>
      <div className="row">
        <div className="col-md-4">
          <select
            id="FormType"
            className="mb-2 form-control "
            onChange={handleCallStatus}
            value={callStatus}
          >
            <option value="" selected="true">
              Select Status
            </option>
            <option value="Not connected">Not connected</option>
            {/* {CallStatusData?.map((ele, i) => {
              return (
                <option key={i} value={ele.name}>
                  {ele.name}
                </option>
              );
            })} */}
          </select>
        </div>
        <div className="col-md-4">
          <select
            id="FormType"
            className="mb-2 form-control "
            onChange={handleParameter}
            value={parameterValue}
          >
            <option value="" selected="true">
              Select Status
            </option>
            {callStatusParameter?.map((ele, i) => {
              return (
                <option key={i} value={ele.name}>
                  {ele.callStatus}
                </option>
              );
            })}
          </select>
        </div>
        <div className="col-md-4">
          <input type="file" accept=".csv" onChange={handlecsvdata} required />
          {csvfileError && (
            <div className="text-danger" style={{ marginTop: 5 + "px" }}>
              {csvfileError}
            </div>
          )}
        </div>
        {submitNullData?.length === 0 && csvfileError === "" && (
          <div className="col-md-4">
            <button
              style={{ marginLeft: 19 + "px" }}
              disabled={disableButton}
              className="btn btn-primary px-5"
              type="submit"
              onClick={handleSubmitCsv}
            >
              submit
            </button>
          </div>
        )}

        <div className="col-md-4">
          {submitNullData?.length > 0 ? (
            <button
              style={{ marginLeft: "25px", width: "226px" }}
              className="btn btn-primary px-5"
              onClick={downloadFinalData}
            >
              Download Report
            </button>
          ) : (
            <div></div>
          )}
        </div>
        <div className="col-md-4">
          <button className="btn btn-primary px-5" onClick={handleClickSample}>
            Download sample
          </button>
        </div>
      </div>
    </>
  );
}

export default CallStatusUpload;
